<template>
    <!-- {is-active} -->
    <div :class="['c-nav-wapper', { 'is-active': isScroll }]">
        <LayoutContent>
            <div class="c-nav-box">
                <div class="nav-main-box">
                    <!-- is-active -->
                    <div :class="['c-mb-handle-box', { 'is-active': isShowMenu }]" @click.stop="handleShowMenu">
                        <span class="c-handle-icon"></span>
                    </div>
                    <div class="c-nav-logo-box">
                        <a href="/">
                            <i class="c-nav-logo"></i>
                        </a>
                    </div>
                    <div class="c-nav-menu-box is-menu" ref="menu">
                        <div class="menu-item is-content">
                            <ul class="c-menu-list-box">
                                <li class="list-item">
                                    <div class="c-menu-inner has-dropdown has-m-dropdown-righttop">
                                        <a :class="['menu-inner-title is-link', { 'is-active': path === '/product' }]">{{ $t("main:产品") }}</a>
                                        <ul class="cd-menu-dropdown">
                                            <li class="dropdown-list">
                                                <a href="/product" class="cd-dropdown-list-item">
                                                    <span class="item-space is-icon"> <i class="gvfont gvfont-case-icon-default"></i></span>
                                                    <span :class="['item-space is-text', { 'is-active': path === '/product' }]">{{ $t("main:游戏语音") }}</span>
                                                </a>
                                            </li>
                                            <!-- <li class="dropdown-list">
                                                <a href="javascript:;" class="cd-dropdown-list-item">
                                                    <span class="item-space is-icon"> <i class="gvfont gvfont-case-icon-default"></i></span>
                                                    <span class="item-space is-text">{{ $t("main:社交IM") }}</span>
                                                </a>
                                            </li> -->
                                        </ul>
                                    </div>
                                </li>
                                <li class="list-item">
                                    <div class="c-menu-inner">
                                        <a href="/case" :class="['menu-inner-title is-link', { 'is-active': path === '/case' }]">{{ $t("main:案例") }}</a>
                                    </div>
                                </li>
                                <li class="list-item">
                                    <div class="c-menu-inner">
                                        <a href="https://docs.qq.com/pdf/DV3pET2RIdXpqTEh1" target="_blank" class="menu-inner-title is-link">{{ $t("main:文档中心") }}</a>
                                    </div>
                                </li>
                              
                                <!-- <li class="list-item">
                                    <div class="c-menu-inner">
                                        <a href="javascript:;" class="menu-inner-title is-link">{{ $t("main:价格") }}</a>
                                    </div>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="c-nav-menu-box">
                    <div class="menu-item">
                        <ul class="c-menu-list-box" v-show="isShow">
                            <!-- <li class="list-item">
                                <div class="c-menu-inner has-dropdown has-m-dropdown-rightbottom">
                                    <a class="menu-inner-title">
                                        <span class="item-space is-text" v-if="lang === 'zh-CN'"
                                            ><span class="c-m-hide">{{ $t("main:简体") }}</span
                                            >{{ $t("main:中文") }}</span
                                        >
                                        <span class="item-space is-text" v-else><span class="c-m-hide">English</span><span class="c-m-block">EN</span></span>
                                    </a>
                                    <ul class="cd-menu-dropdown">
                                        <li class="dropdown-list">
                                            <a href="javascript:;" class="cd-dropdown-list-item" @click="changeLang(LANG_EN)">
                                                <span class="item-space is-text"><span class="c-m-hide">English</span><span class="c-m-block">EN</span></span>
                                            </a>
                                        </li>
                                        <li class="dropdown-list">
                                            <a href="javascript:;" class="cd-dropdown-list-item" @click="changeLang(LANG_CN)">
                                                <span class="item-space is-text"
                                                    ><span class="c-m-hide">{{ $t("main:简体") }}</span
                                                    >{{ $t("main:中文") }}</span
                                                >
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li> -->

                            <li class="list-item" v-if="userInfo">
                                <div class="c-menu-inner has-dropdown has-m-dropdown-rightbottom">
                                    <a class="menu-inner-title is-link">
                                        <span class="item-space is-text has-text-overflow">{{ userInfo.UserName || userInfo.UserID }}</span>
                                    </a>
                                    <ul class="cd-menu-dropdown">
                                        <li class="dropdown-list">
                                            <a href="javascript:;" class="cd-dropdown-list-item" @click="handleLogout">
                                                <span class="item-space is-text">{{ $t("main:退出") }}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li class="list-item" v-else>
                                <div class="c-menu-inner has-dropdown has-m-dropdown-rightbottom is-pc-item">
                                    <p class="menu-inner-title">
                                        <i class="gvfont gvfont-denglu"></i>
                                    </p>
                                    <ul class="cd-menu-dropdown">
                                        <li class="dropdown-list">
                                            <a href="javascript:;" class="cd-dropdown-list-item" @click.stop="handleLogin">
                                                <span class="item-space is-text">{{ $t("main:登录") }}</span>
                                            </a>
                                        </li>
                                        <!-- <li class="dropdown-list">
                                            <a href="javascript:;" class="cd-dropdown-list-item">
                                                <Button type="primary" size="middle" :adaptation="true">{{ $t("main:立即注册") }}</Button>
                                            </a>
                                        </li> -->
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div></LayoutContent
        >
    </div>
</template>

<script>
import Button from "@/components/UI/Button.vue";
import LayoutContent from "@/components/UI/LayoutContent.vue";
import { store, event } from "@ice/stark-data";
import { LANG_EN, LANG_CN, getCookie, clearCookie } from "@/utils/commons";
import { changeLang, getLang } from "@/utils/i18n";

export default {
    name: "Nav",
    components: { Button, LayoutContent },
    data() {
        return {
            isShow: true,
            isScroll: false,
            isShowMenu: false,
            userInfo: store.get("userInfo"),
            LANG_EN,
            LANG_CN,
            lang: getLang(),
            path: this.$route.path,
        };
    },
    mounted() {
        this.callback = ((data) => {
            this.userInfo = data;
        }).bind(this);
        event.on("refreshStatus", this.callback);

        $(document).bind("click", (e) => {
            if (!this.$refs.menu.contains(e.target) && this.isShowMenu) {
                this.isShowMenu = false;
            }
        });

        this.handleScroll();
        $(window).scroll(this.handleScroll);
    },
    destroyed() {
        event.off("refreshStatus", this.callback);
    },
    methods: {
        handleScroll() {
            this.isScroll = $(window).scrollTop() > 0;
        },

        // 控制菜单显示
        handleShowMenu() {
            this.isShowMenu = !this.isShowMenu;
        },

        // 跳转登录页面
        handleLogin() {
            let loginUrl = "";

            if (getCookie("i18next") === "en-GB") {
                loginUrl = `http://email.gcloud.tencent.com/mail/login?backurl=${encodeURIComponent(window.location.href)}`;
            } else {
                loginUrl = `http://web.gcloud.qq.com/qqlogin?backurl=${encodeURIComponent(window.location.href)}`;
            }

            window.location.href = loginUrl;
        },

        changeLang(lang) {
            changeLang(lang);
        },

        // 退出登录
        async handleLogout() {
            clearCookie("GCLOUD_ID");
            clearCookie("GCLOUD_SESSIONKEY");

            try {
                const { data: res } = await this.$http.get("/api/basic/logout");
                if (res.code === 0) {
                    window.location.href = "/";
                }
            } catch (err) {
                console.log(err);
            }
        },
    },
};
</script>

<style scoped lang="less">
.c-mb-handle-box {
    display: none;
    margin-right: 8px;
}
.c-handle-icon {
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.08);
    &::before,
    &::after {
        content: "";
        display: inline-block;
        width: 16px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.88);
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        transition: ease-in-out 0.16s;
    }
    &::before {
        top: -12px;
    }
    &::after {
        bottom: -12px;
    }
}
.c-nav-wapper {
    display: flex;
    padding-left: 16px;
    padding-right: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    background-color: rgba(27, 28, 49, 0.6);
    transition: ease-in-out 0.8s;
    &.is-active {
        background-color: rgba(27, 28, 49, 1);
        transition: ease-in-out 0.8s;
    }
}
.c-nav-logo-box {
    margin-top: -8px;
    & + .c-nav-menu-box {
        margin-left: 32px;
    }
}
.c-nav-box {
    display: flex;
    align-items: center;
    height: 80px;
    .nav-main-box {
        flex: 1;
        display: flex;
        align-items: center;
        height: 100%;
    }
}
.c-nav-menu-box {
    display: flex;
    align-items: center;
    height: 100%;
    &.is-menu {
        flex: 1;
    }
    .menu-item {
        display: flex;
        height: 100%;
        &.is-content {
            flex: 1;
        }
    }
}
.c-nav-logo {
    display: inline-block;
    width: 320px;
    height: 36px;
    background: url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-tencent-game-gvoice.png) no-repeat center center;
    background-size: contain;
}
.c-menu-list-box {
    display: flex;
    align-items: center;
    height: 100%;
    .list-item {
        display: inline-flex;
        align-items: center;
        height: 100%;
        & + .list-item {
            margin-left: 8px;
        }
    }
}
.c-menu-inner {
    display: inline-flex;
    height: 100%;
    &.has-dropdown {
        position: relative;
        margin-right: -20px;
        &:hover {
            .cd-menu-dropdown {
                height: auto;
                top: 100%;
                opacity: 1;
                transition: ease-in-out 0.24s;
                overflow: visible;
            }
        }
        .menu-inner-title {
            &:hover {
                &::after {
                    border-top-color: #4e67ff;
                }
            }
            &::after {
                content: "";
                display: inline-block;
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 6px solid #fff;
                margin-left: 8px;
            }
        }
    }
    .menu-inner-title {
        display: inline-flex;
        align-items: center;
        padding: 0 24px;
        font-size: 16px;
        line-height: 1;
        color: #fff;
        white-space: nowrap;
        &.is-link {
            transition: ease-in-out 0.16s;
            &:hover {
                color: #415cf9;
                transition: ease-in-out 0.16s;
            }
            &.is-active {
                color: #415cf9;
            }
        }
        .item-space {
            &.is-text {
                &.has-text-overflow {
                    display: inline-block;
                    max-width: 264px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
        .gvfont-denglu {
            font-size: 22px;
        }
    }
}
.cd-menu-dropdown {
    display: inline-flex;
    flex-direction: column;
    min-width: 100%;
    height: 0;
    padding: 0 16px;
    border-radius: 8px;
    position: absolute;
    left: 0;
    top: 60%;
    z-index: 80;
    transition: ease-in-out 0.24s;
    box-shadow: rgba(0, 0, 0, 0.6) 0 0 4px;
    background-color: #141627;
    opacity: 0;
    overflow: hidden;
    &::before {
        content: "";
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #141627;
        transform: rotate(45deg);
        margin-left: 24px;
        position: absolute;
        bottom: calc(~"100% - 6px");
    }
    .dropdown-list {
        position: relative;
        z-index: 2;
        & + .dropdown-list {
            border-top: 1px solid #424661;
        }
    }
}
.cd-dropdown-list-item {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 68px;
    padding: 0 8px;
    &:hover {
        .item-space {
            &.is-text {
                color: #415cf9;
            }
        }
    }
    &.is-active {
        color: #415cf9;
    }
    .item-space {
        color: #fff;
        white-space: nowrap;
        font-size: 16px;
        line-height: 1;
        & + .item-space {
            margin-left: 16px;
        }
        &.is-icon {
            .gvfont {
                font-size: 18px;
            }
        }
        &.is-active {
            color: #415cf9;
        }
    }
}
.c-m-block {
    display: none;
}
@media screen and (min-width: 640px) {
    .c-menu-inner {
        &.is-pc-item {
            margin-right: 0;
            .menu-inner-title {
                display: none;
            }
            .cd-menu-dropdown {
                flex-direction: unset;
                align-items: center;
                height: auto;
                position: unset;
                opacity: 1;
                overflow: visible;
                background-color: transparent;
                box-shadow: none;
                &::before {
                    display: none;
                }
                .dropdown-list {
                    & + .dropdown-list {
                        margin-left: 16px;
                        border-top: none;
                    }
                }
            }
        }
    }
}
@media only screen and (max-width: 1200px) {
    .c-menu-inner {
        &.has-dropdown {
            .menu-inner-title {
                &::after {
                    border-left: 3px solid transparent;
                    border-right: 3px solid transparent;
                    border-top: 3px solid #fff;
                    margin-left: 4px;
                }
            }
        }
        .menu-inner-title {
            padding: 0 16px;
            font-size: 14px;
        }
    }
    .c-nav-logo-box {
        margin-top: -4px;
    }
    .c-nav-box {
        height: 48px;
    }
    .c-nav-logo {
        width: 240px;
        height: 32px;
    }
    .cd-menu-dropdown {
        padding: 0 8px;
    }
    .cd-dropdown-list-item {
        min-height: 48px;
        .item-space {
            font-size: 14px;
            & + .item-space {
                margin-left: 8px;
            }
            &.is-icon {
                .gvfont {
                    font-size: 14px;
                }
            }
        }
    }
}

@media only screen and (max-width: 995px) {
    .c-mb-handle-box {
        display: inline-flex;
        &.is-active {
            & + .c-nav-logo-box {
                & + .c-nav-menu-box {
                    &.is-menu {
                        left: 0;
                        transition: ease-in-out 0.32s;
                    }
                }
            }
            .c-handle-icon {
                background-color: rgb(1, 2, 7);
                &::after,
                &::before {
                    background-color: #4e67ff;
                }
            }
        }
    }
    .c-nav-menu-box {
        &.is-menu {
            position: fixed;
            background-color: rgb(21, 22, 37);
            left: -104px;
            margin: 0;
            top: 48px;
            width: 104px;
            box-shadow: rgba(0, 0, 0, 0.8) 0 0 8px;
            transition: ease-in-out 0.24s;
            .c-menu-list-box {
                flex-direction: column;
                width: 100%;
                height: auto;
                .list-item {
                    width: 100%;
                    height: auto;
                    &.has-button {
                        justify-content: center;
                        padding-top: 8px;
                        padding-bottom: 8px;
                    }
                    & + .list-item {
                        margin-left: 0;
                        margin-top: 1px;
                    }
                }
            }
            .c-menu-inner {
                .menu-inner-title {
                    width: 100%;
                    padding: 16px 24px;
                    background-color: #282935;
                    &::after {
                        transform: rotate(-90deg);
                    }
                }
            }
        }
    }

    .c-menu-inner {
        width: 100%;
        height: 100%;
        &.has-m-dropdown-righttop {
            &:hover {
                .cd-menu-dropdown {
                    top: 0;
                    left: 100%;
                }
            }
            .cd-menu-dropdown {
                top: 0;
                right: auto;
                left: 80%;
                &:before {
                    right: calc(100% - 4px);
                    top: 16px;
                    bottom: auto;
                }
            }
        }
        &.has-m-dropdown-rightbottom {
            &:hover {
                .cd-menu-dropdown {
                    top: 100%;
                }
            }
            .cd-menu-dropdown {
                top: 80%;
                right: -8px;
                left: auto;
                &:before {
                    right: 22px;
                    top: -4px;
                    bottom: auto;
                }
            }
        }
        .menu-inner-title {
            .item-space {
                &.is-text {
                    &.has-text-overflow {
                        max-width: 360px;
                    }
                }
            }
        }
    }
    .cd-menu-dropdown {
        &:before {
            width: 8px;
            height: 8px;
            top: -4px;
            margin-left: 12px;
        }
    }
    .cd-dropdown-list-item {
        min-height: 40px;
        .item-space {
            font-size: 12px;
        }
        .c-button {
            &.is-middle {
                min-height: 28px;
                font-size: 12px;
            }
        }
    }
    .c-m-hide {
        display: none;
    }
    .c-m-block {
        display: block;
    }
}
@media only screen and (max-width: 768px) {
    .c-nav-logo {
        width: 160px;
    }
    .c-menu-inner {
        .menu-inner-title {
            .item-space {
                &.is-text {
                    &.has-text-overflow {
                        max-width: 160px;
                    }
                }
            }
        }
    }
}
@media only screen and (max-width: 480px) {
    .c-menu-inner {
        .menu-inner-title {
            .item-space {
                &.is-text {
                    &.has-text-overflow {
                        max-width: 64px;
                    }
                }
            }
        }
    }
}
</style>
